
  import LzSubscription from "@/components/Subscription.vue";
  import { Component, Vue } from "vue-property-decorator";

  @Component({ components: { LzSubscription } })
  export default class StepSubscription extends Vue {}
